import Content from '../../content.js';

namespace('IO.Views.Customers', function (exports) {
  'use strict';

  var New = Content.extend({
    dom: {
      SELECT2_FIELD: '.select2select',
      STORE_NUMBER_FIELD: '.store-number-field',
      SUBMIT_BUTTON: 'form .submit',
      EDIT_BUTTON: '.io-form-action-edit',
      SITE_FEATURES: '.features input',
      RJE_FEATURE: '#feature_remote_job_execution',
      RJE_OPTIONS: '.rje_opts',
      PD_FEATURE: '#feature_payment_devices',
      PD_OPTIONS: '.pd_opts',
      EM_FEATURE: '#opt_estate_management',
      EM_OPTIONS: '.em_opts',
      API_FEATURE: '#feature_api',
      API_OPTIONS: '.api_opts',
      API_CALLS_LIMIT: '#customer_api_calls_limit',
      API_CALLS_LIMIT_WINDOW: '#customer_api_calls_limit_window',
      COMPANY_HANDLE_TRIGGER: '.company_handle_trigger',
      CUSTOMER_CODE_INPUT_FIELD: '.customer-code',
      CUSTOMER_COMPANY_HANDLE_FIELD: '#customer_company_handle',
      CUSTOMER_ADDRESS_STATE_FIELD: '#subdivisions-select',
      FEATURE_OPTIONS: '.feature_options input',
      TERMINAL_VALIDATION: '.validation-enabler',
      TERMINAL_VAL_SUBFIELDS: '.validation-subfields',
      URI_ES_CONFIG_API: '#elastic_search_config_form #uri_field',
      API_KEY_ES_CONFIG_API: '#elastic_search_config_form #api_key_field',
      TEST_CONNECTION_ES_CONFIG_BUTTON:
        '#test_connection_elastic_search_config',
      TEST_CONNECTION_ES_CONFIG_RESULT_TEXT:
        '#elastic_search_config_form #test_connection_result',
      AUTH_METHOD_ENABLED_RADIO: '.auth_method_enable',
      AUTH_METHOD_TR: '.auth_method',
      AUTH_METHOD_SELECT: '.auth_method_select',
      DUO_CONFIG_FORM: '#duo_config',
      SAML_CONFIG_FORM: '#saml_config',
      EXPORTERS_ENABLED_BUTTON: 'button#exporters_enabled_field',
    },

    _modalActive: false,

    events: function () {
      var events = {};

      events['click ' + this.dom.SUBMIT_BUTTON] = '_checkStoreNumberChange';
      events['submit form'] = '_syncCompanyHandleForSubmit';
      events['click ' + this.dom.EDIT_BUTTON] = '_toggleSubfields';
      events['click ' + this.dom.EDIT_BUTTON] =
        '_disableDeprecatedAuthAPIRadioButton';
      events['change ' + this.dom.SITE_FEATURES] = '_toggleFeatures';
      events['change ' + this.dom.API_CALLS_LIMIT] = '_apiCallsLimitChange';
      events['change ' + this.dom.FEATURE_OPTIONS] = '_toggleOptions';
      events['change ' + this.dom.TERMINAL_VALIDATION] =
        '_toggleTerminalValidationSubfields';
      events['input change ' + this.dom.COMPANY_HANDLE_TRIGGER] =
        '_updateCompanyHandleField';
      events['click ' + this.dom.TEST_CONNECTION_ES_CONFIG_BUTTON] =
        '_testConnection';
      events['keyup ' + this.dom.URI_ES_CONFIG_API] =
        '_disableEnableTestConnectionButton';
      events['keyup ' + this.dom.API_KEY_ES_CONFIG_API] =
        '_disableEnableTestConnectionButton';

      events['change ' + this.dom.AUTH_METHOD_ENABLED_RADIO] =
        '_refreshAuthMethodSelect';
      events['change ' + this.dom.AUTH_METHOD_SELECT] = '_renderAuthMethodForm';
      events['click ' + this.dom.EXPORTERS_ENABLED_BUTTON] = '_toggleExporters';

      return events;
    },

    render: function () {
      this._updateCompanyHandleField();
      // eslint-disable-next-line vars-on-top
      var $select = this.$(this.dom.SELECT2_FIELD),
        self = this,
        _prepareDependentOptions;

      if (!$select.closest('.hide').length) {
        $select.select2();
      }
      this.checkRadioButtons();

      _prepareDependentOptions = function (domOpts, domFeature) {
        var opts = self.$el.find(domOpts);

        if ($(domFeature).prop('checked')) {
          opts.find('input').removeClass('locked');
        } else {
          opts.prop('disabled', true);
          opts.find('input').prop('disabled', true);
        }
      };

      _prepareDependentOptions(this.dom.EM_OPTIONS, this.dom.EM_FEATURE);
      _prepareDependentOptions(this.dom.PD_OPTIONS, this.dom.PD_FEATURE);
      _prepareDependentOptions(this.dom.RJE_OPTIONS, this.dom.RJE_FEATURE);
      _prepareDependentOptions(this.dom.API_OPTIONS, this.dom.API_FEATURE);
      PropertyTypeMask.applyMasks.call(this);

      setTimeout(function () {
        // Not beautiful but necessary because the select is
        // not instantiated immediately
        self._apiCallsLimitChange();
      }, 200);

      this._disableEnableTestConnectionButton();
      this._refreshAuthMethodSelect();
    },

    _isEditing: function () {
      return $('.-editing').length;
    },

    _disableDeprecatedAuthAPIRadioButton: function () {
      // input#method0 is the "Auth API (deprecated)" option for Duo Integration.
      // We are disabling it for selection to encourage transition to the WebSDK
      // method of 2FA.
      // When all customers have migrated to Duo Web SDK application protection type
      // we can remove this code.
      var deprecatedAuthAPIRadio = $('td.radio input#method0');

      if (deprecatedAuthAPIRadio.length) {
        deprecatedAuthAPIRadio.prop('disabled', true);
      }
    },

    _refreshAuthMethodSelect: function () {
      let value = $(this.dom.AUTH_METHOD_ENABLED_RADIO + ':checked').val();

      if (value == 'true') {
        $(this.dom.AUTH_METHOD_TR).show();
      } else {
        $(this.dom.AUTH_METHOD_TR).hide();
        $(this.dom.AUTH_METHOD_SELECT).val(null);
        $(this.dom.AUTH_METHOD_SELECT).trigger('change');
      }
      this._renderAuthMethodForm();
    },

    _renderAuthMethodForm: function () {
      const hide = (form) => {
        form.hide();
        form.find($(':input')).each((_, e) => {
          if ($(e).prop('type') == 'hidden') {
            $(e).prop('value', false);
          } else {
            $(e).prop('disabled', true);
          }
        });
      };
      const show = (form) => {
        form.show();
        form.find($(':input')).each((_, e) => {
          if ($(e).prop('type') == 'hidden') {
            $(e).prop('value', true);
          } else {
            $(e).prop('disabled', !this._isEditing());
          }
        });
      };

      let value = $(this.dom.AUTH_METHOD_SELECT).first().val(),
        duoForm = $(this.dom.DUO_CONFIG_FORM).first(),
        samlForm = $(this.dom.SAML_CONFIG_FORM).first();

      if (value == 'saml') {
        show(samlForm);
        hide(duoForm);
      } else if (value == 'duo') {
        show(duoForm);
        hide(samlForm);
      } else {
        hide(duoForm);
        hide(samlForm);
      }
    },

    _apiCallsLimitChange: function () {
      var el = $(this.dom.API_CALLS_LIMIT_WINDOW).next(),
        apiCalls = $(this.dom.API_CALLS_LIMIT).val();

      if (apiCalls == 0 || apiCalls == '') {
        el.hide();
      } else {
        el.show();
      }
    },

    /**
     * company_handle is disabled in the DOM until submit; disabled fields are not posted.
     * Also run on submit (e.g. Enter in a field) — submit click alone does not cover that.
     * Sync immediately so the last keystroke in Code is included before serialization.
     */
    _syncCompanyHandleForSubmit: function () {
      if ($(this.dom.EDIT_BUTTON).length) {
        return;
      }
      this._updateCompanyHandleField();
      $(this.dom.CUSTOMER_COMPANY_HANDLE_FIELD).prop('disabled', false);
    },

    _checkStoreNumberChange: function (e) {
      var msg, $storeNumberField;

      this._syncCompanyHandleForSubmit();

      if ($(e.target).hasClass('customer-submit-triggered')) {
        $(e.target).removeClass('customer-submit-triggered');
        return true;
      }

      $storeNumberField = this.$(this.dom.STORE_NUMBER_FIELD);
      if (
        $storeNumberField.val() ===
        $storeNumberField.data('original').toString()
      ) {
        return;
      }

      e.preventDefault();

      msg =
        "You have changed the node's store number size.<br>" +
        'There are critical consequences if proceeding.<br>Are you sure?';

      this._showModal(msg, function (answer) {
        if (answer === false) {
          return;
        }

        $(e.target).addClass('customer-submit-triggered');
        $(e.target).submit();
      });

      return false;
    },

    _toggleExporters: function (e) {
      let checkbox = $(e.target).siblings('input[type="checkbox"]')[0];
      checkbox.checked = !checkbox.checked;
    },

    _prepareModalForFeatures: function (
      requiredOpt,
      dependentOpt,
      confirmationCallback,
    ) {
      var self = this,
        templateData;

      templateData = {
        hosts: null,
        dependentOpt: dependentOpt,
        requiredOpt: requiredOpt,
        maxImpactedHostnamesShown: 20,
      };

      if (dependentOpt === 'Remote Job Execution') {
        $.ajax({
          url: window.location.pathname + '/node_and_server_hosts_by_type.json',
          data: { type_of_server: 'Device Management' }, // eslint-disable-line camelcase
          success: function (data) {
            templateData.hosts = data.hosts;
            self._showModal(
              JST['templates/customers/disabling_features_warning'](
                templateData,
              ),
              confirmationCallback,
            );
          },
        });
      } else {
        this._showModal(
          JST['templates/customers/disabling_features_warning'](templateData),
          confirmationCallback,
        );
      }
    },

    _showModal: function (msg, confirmationCallback) {
      if (!this.confirmationModal) {
        this.confirmationModal = new IO.Views.ConfirmationModal({
          el: '#confirmation-modal',
          closeable: false,
        });
      }

      this.confirmationModal.show(msg, confirmationCallback);
      $('.modal-background').css({ zIndex: 100 });
    },

    _enableFeature: function (featureName) {
      var self = this,
        feature = $('#feature_' + featureName),
        depOpts = this.$el
          .find('[data-feature-symbol="' + featureName + '"]')
          .not(feature[0]),
        depFields = this.$el.find('.feature-dependency-' + featureName);

      depFields.removeClass('hidden');

      // Before updating the option check the required option from other feature.
      depOpts.each(function (_, option) {
        var required = $(
          self._processFeatureOptions(
            $(option).data('feature-option-required'),
          ),
        );

        if (required.length > 0 && !required.is(':checked')) {
          depOpts.splice($.inArray($(option), depOpts), 1);
        }
      });

      depOpts.prop('disabled', false);
      depOpts.removeClass('disabled');
    },

    _disableFeature: function (featureName) {
      var self = this,
        feature = $('#feature_' + featureName),
        depOpts = this.$el
          .find('[data-feature-symbol="' + featureName + '"]')
          .not(feature[0]),
        depFields = this.$el.find('.feature-dependency-' + featureName),
        _doIt,
        _confirmationCallback,
        needsConfirmation,
        dependent,
        required,
        msg;

      _doIt = function () {
        depFields.addClass('hidden');
        depOpts.prop('disabled', true);
        depOpts.prop('disabled', true).prop('checked', false);
        self._modalActive = false;
      };

      // Disable option under other feature that depends on this disabled option.
      needsConfirmation = [];
      depOpts.each(function (_, option) {
        dependent = $(
          self._processFeatureOptions(
            $(option).data('feature-option-dependent'),
          ),
        );
        if (dependent.length > 0) {
          $.merge(depOpts, dependent);
        }

        // If child option has a required option that is enabled ask for confirmation, if there's any.
        required = $(
          self._processFeatureOptions(
            $(option).data('feature-option-required'),
          ),
        );
        if (required.length > 0 && $(option).is(':checked')) {
          needsConfirmation.push(required);
        }
      });

      _confirmationCallback = function (proceed) {
        if (proceed === true) {
          _doIt();
        } else {
          feature.prop('checked', true);
          self._modalActive = false;
        }
      };

      this._modalActive = true;
      if (
        needsConfirmation.length > 0 ||
        featureName === 'remote_job_execution'
      ) {
        msg = needsConfirmation.map(function (req) {
          return '<b>' + req.parent().text().trim() + '</b>';
        });

        this._prepareModalForFeatures(
          msg.join(', '),
          feature.parent().text().trim(),
          _confirmationCallback,
        );
      } else if (hierarchyActive && featureName === 'levels_of_hierarchy') {
        msg =
          'Stores are being managed by Levels of Hierarchy, disabling this function<br>' +
          "will change store management to 'No management'.<br><br>Is that what you want?";

        this._showModal(msg, _confirmationCallback);
      } else {
        _doIt();
      }
    },

    _toggleFeatures: function (e) {
      var featureName = $(e.currentTarget).data('feature-symbol');

      if (e.currentTarget.checked === true) {
        this._enableFeature(featureName);
      } else {
        this._disableFeature(featureName);
      }

      if (this._modalActive) {
        return;
      }
      this._toggleFeatureWarning(
        featureName,
        e.currentTarget,
        e.currentTarget.checked,
      );
    },

    _toggleFeatureWarning: function (featureName, element, showWarn) {
      var changedFeature = $(element).closest('li'),
        url = window.location.pathname + '/impacted_resources.json',
        message =
          'Warning! Disabling this feature will delete any existing data.';

      if (showWarn) {
        changedFeature.find('p#feature-warning').remove();
      } else {
        $.ajax({
          url: url,
          data: { feature: featureName },
          success: function (data) {
            if (data.impacted_resources) {
              changedFeature.append(
                '<p id="feature-warning" class="pref-diff">' + message + '</p>',
              );
            }
          },
        });
      }
    },

    _toggleTerminalValidationSubfields: function () {
      this._toggleSubfields();
      this._setMinAndMaxValue();
    },

    _updateCompanyHandleField: function () {
      if ($(this.dom.EDIT_BUTTON).length) {
        return;
      }
      let customerCompanyField = $(this.dom.CUSTOMER_COMPANY_HANDLE_FIELD);
      let customerCodeField = $(this.dom.CUSTOMER_CODE_INPUT_FIELD)[0];
      let customerAddressStateField = $(
        this.dom.CUSTOMER_ADDRESS_STATE_FIELD,
      )[0];

      if (customerCodeField && customerAddressStateField) {
        var code = String(customerCodeField.value || '')
          .trim()
          .toLowerCase()
          .slice(0, 3);
        var region = String(customerAddressStateField.value || '')
          .trim()
          .toLowerCase()
          .slice(0, 2);
        customerCompanyField.val(`${code}${region}`);
      }
    },

    _setMinAndMaxValue: function () {
      var disabled = $('#disabled-validation').attr('checked'),
        minFieldValue = $('#customer_terminal_id_validation_min'),
        maxFieldValue = $('#customer_terminal_id_validation_max');

      if (disabled) {
        minFieldValue.val('');
        maxFieldValue.val('');
      } else if (minFieldValue.val() === '' && maxFieldValue.val() === '') {
        minFieldValue.val(1);
        maxFieldValue.val(13);
      }
    },

    _toggleSubfields: function () {
      var disabled = $('#disabled-validation').attr('checked'),
        subfields = $(this.dom.TERMINAL_VAL_SUBFIELDS);

      subfields.find('input').attr('readonly', disabled);
      subfields
        .find('input#terminal_id_validation_required_fields_')
        .attr('disabled', disabled);

      if (disabled) {
        subfields.find('span').addClass('disabled');
      } else {
        subfields.find('span').removeClass('disabled');
      }
    },

    _toggleOptions: function (e) {
      var option = $(e.currentTarget),
        required = $(
          this._processFeatureOptions(
            $(option).data('feature-option-required'),
          ),
        ),
        dependent = $(
          this._processFeatureOptions(
            $(option).data('feature-option-dependent'),
          ),
        ),
        depFields = this.$el.find('.feature-option-dependency-' + option.val()),
        featureName,
        feature,
        _updateDependent;

      if (e.currentTarget.checked === true) {
        depFields.removeClass('hidden');
      } else {
        depFields.addClass('hidden');
      }

      if (option.is(':checked') && dependent.length > 0) {
        featureName = dependent.data('feature-symbol');
        feature = $('#feature_' + featureName);
        if (!feature.is(':checked')) {
          this._enableFeature(featureName);
          feature.prop('checked', true);
        }
        dependent.prop('checked', true);
      }

      _updateDependent = function () {
        var depedentFeature;

        if (dependent.length === 0) {
          return;
        }

        depedentFeature = $('#feature_' + dependent.data('feature-symbol'));
        if (
          option.is(':checked') &&
          (depedentFeature.length == 0 || depedentFeature.is(':checked'))
        ) {
          dependent.prop('disabled', false);
        } else {
          dependent.prop('disabled', true);
        }
      };

      if (required.length > 0 && option.is(':checked') === false) {
        this._prepareModalForFeatures(
          required.parent().text().trim(),
          option.parent().text().trim(),
          function (proceed) {
            if (proceed === true) {
              return;
            }
            option.prop('checked', true);
            _updateDependent();
          },
        );
      } else {
        _updateDependent();
      }
    },

    _processFeatureOptions: function (featureOpts) {
      if (featureOpts === undefined) {
        return undefined;
      }
      return featureOpts
        .split(' ')
        .map(function (item) {
          return '#' + item;
        })
        .join(', ');
    },

    _disableEnableTestConnectionButton: function () {
      let uriValue = $(this.dom.URI_ES_CONFIG_API).val(),
        apiKeyValue = this._getMaskPasswordValue(
          $(this.dom.API_KEY_ES_CONFIG_API),
        );

      if (!uriValue || !apiKeyValue) {
        $(this.dom.TEST_CONNECTION_ES_CONFIG_BUTTON)
          .prop('disabled', true)
          .addClass('disabled');
      } else {
        $(this.dom.TEST_CONNECTION_ES_CONFIG_BUTTON)
          .prop('disabled', false)
          .removeClass('disabled');
      }
    },

    _testConnection: function () {
      $(this.dom.TEST_CONNECTION_ES_CONFIG_BUTTON)
        .prop('disabled', true)
        .addClass('disabled loading');
      $(this.dom.TEST_CONNECTION_ES_CONFIG_RESULT_TEXT)
        .text('')
        .removeClass('success error');

      let attributes = {
        connection: {
          uri: $(this.dom.URI_ES_CONFIG_API).val(),
          api_key: this._getMaskPasswordValue(
            $(this.dom.API_KEY_ES_CONFIG_API),
          ),
        },
      };

      $.ajax({
        method: 'POST',
        url: `/${currentCustomer}/customers/${currentCustomer}/test_connection_elastic_search_config`,
        data: attributes,
      }).done((response) => {
        if (response.success) {
          let message = `Successfully connected to Elasticsearch on ${attributes.connection.uri}`;

          $(this.dom.TEST_CONNECTION_ES_CONFIG_RESULT_TEXT)
            .text(message)
            .addClass('success');
        } else {
          let message = `Error connecting to Elasticsearch on ${attributes.connection.uri}`;

          $(this.dom.TEST_CONNECTION_ES_CONFIG_RESULT_TEXT)
            .text(message)
            .addClass('error');
        }
        $(this.dom.TEST_CONNECTION_ES_CONFIG_BUTTON)
          .prop('disabled', false)
          .removeClass('disabled loading');
      });
    },

    _getMaskPasswordValue: function (maskPassword) {
      let value = maskPassword.val();

      if (value === '********') {
        value = maskPassword[0].defaultValue;
      }
      return value;
    },
  });

  exports.New = New;
});
